import {
  Shield,
  Users,
  Lightbulb,
  Heart,
  Target,
  Award,
  LucideIcon,
} from 'lucide-react';

export interface ValuesInfo {
  icon: LucideIcon;
  title: string;
  description: string;
}

export interface TeamInfo {
  name: string;
  role: string;
  bio: string;
  initials: string;
  imageUrl: string;
  linkedInUrl: string;
}

export interface AppAboutInfo {
  id: number;
  type: 'XanecTech' | 'Admin' | 'TrueID.Locker' | 'Company';
  app_name: string;
  app_descriptive_name?: string;
  app_description?: string;
  version: string;
  copyright: string;
  is_current: boolean;
  release_date: string;
  release_notes_link: string;
  privacy_policy: string;
  terms_of_service: string;
  info_email: string;
  contact_email: string;
  created_at: string;
  updated_at: string;
}

export const AppAboutInfo: AppAboutInfo[] = [
  {
    id: 1,
    type: 'XanecTech',
    app_name: 'XanecTech',
    app_descriptive_name: 'Xanec Technologies',
    app_description:
      'XanecTech is a cutting-edge technology company dedicated to providing innovative solutions for businesses and individuals. Our mission is to empower our clients with the latest advancements in technology, enabling them to achieve their goals and stay ahead in a rapidly evolving digital landscape.',
    version: '1.0.0',
    copyright: '© 2025 Xanec Technologies. All rights reserved.',
    is_current: true,
    release_date: '2025-09-30',
    release_notes_link: 'https://www.xanectech.com/release-notes',
    privacy_policy:
      'At Xanec Technologies, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you use our services. By using our platform, you consent to the practices described in this policy. Link: https://www.xanectech.com/privacy-policy',
    terms_of_service:
      'Welcome to Xanec Technologies! By using our services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our platform. If you do not agree to these terms, please do not use our services. Link: https://www.xanectech.com/terms-of-service',
    info_email: 'info@xanectech.com',
    contact_email: 'info@xanectech.com',
    created_at: '2025-09-06 08:25:15.965269+00',
    updated_at: '2026-03-26 13:45:41.773302',
  },
  {
    id: 4,
    type: 'Admin',
    app_name: 'Admin',
    app_descriptive_name: 'Admin Portal',
    app_description:
      'The Admin Portal is a powerful web application designed to provide administrators with comprehensive tools and features for managing and overseeing various aspects of their organization. It offers a user-friendly interface that allows administrators to efficiently handle tasks such as user management, system configuration, data analysis, and reporting. With the Admin Portal, administrators can streamline their operations, enhance productivity, and ensure the smooth functioning of their organization.',
    version: '1.0.0',
    created_at: '2026-01-05 16:38:38.77744+00',
    updated_at: '2026-03-26 13:45:41.773302',
    release_date: '2025-09-30',
    copyright: '© 2025 Xanec Technologies. All rights reserved.',
    is_current: true,
    release_notes_link: 'https://www.xanectech.com/release-notes',
    terms_of_service:
      'Welcome to Xanec Technologies! By using our services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our platform. If you do not agree to these terms, please do not use our services. Link: https://www.xanectech.com/terms-of-service',
    privacy_policy:
      'At Xanec Technologies, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you use our services. By using our platform, you consent to the practices described in this policy. Link: https://www.xanectech.com/privacy-policy',
    contact_email: 'info@xanectech.com',
    info_email: 'info@xanectech.com',
  },
  {
    id: 5,
    type: 'TrueID.Locker',
    app_name: 'TrueID.Locker',
    app_descriptive_name: 'TrueID.Locker',
    app_description:
      'Personal information management, always secure, always accessible.',
    created_at: '2026-02-26 05:58:51.14582+00',
    updated_at: '2026-03-26 13:45:41.773302',
    version: '1.0.0',
    release_date: '2025-09-30',
    copyright: '© 2025 Xanec Technologies. All rights reserved.',
    is_current: true,
    release_notes_link: 'https://www.xanectech.com/release-notes',
    terms_of_service:
      'Welcome to Xanec Technologies! By using our services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our platform. If you do not agree to these terms, please do not use our services. Link: https://www.xanectech.com/terms-of-service',
    privacy_policy:
      'At Xanec Technologies, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you use our services. By using our platform, you consent to the practices described in this policy. Link: https://www.xanectech.com/privacy-policy',
    contact_email: 'info@xanectech.com',
    info_email: 'info@xanectech.com',
  },
  {
    id: 6,
    type: 'Company',
    app_name: 'Company',
    app_descriptive_name: 'Company Portal',
    app_description:
      'The Company Portal is a comprehensive web application where companies manage their data contracts and integrations. It provides a user-friendly interface for companies to easily create, view, and manage their data contracts, ensuring seamless integration with various platforms and services. The Company Portal streamlines the process of data management, allowing companies to efficiently handle their data contracts and integrations in one centralized location.',
    created_at: '2026-02-26 05:59:02.061019+00',
    updated_at: '2026-03-26 13:45:41.773302',
    version: '1.0.0',
    release_date: '2025-09-30',
    copyright: '© 2025 Xanec Technologies. All rights reserved.',
    is_current: true,
    release_notes_link: 'https://www.xanectech.com/release-notes',
    terms_of_service:
      'Welcome to Xanec Technologies! By using our services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our platform. If you do not agree to these terms, please do not use our services. Link: https://www.xanectech.com/terms-of-service',
    privacy_policy:
      'At Xanec Technologies, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you use our services. By using our platform, you consent to the practices described in this policy. Link: https://www.xanectech.com/privacy-policy',
    contact_email: 'info@xanectech.com',
    info_email: 'info@xanectech.com',
  },
];

export const VALUES: ValuesInfo[] = [
  {
    icon: Shield,
    title: 'Security First',
    description:
      'We believe privacy and security are fundamental rights, not features. Every product we build starts with protection at its core.',
  },
  {
    icon: Users,
    title: 'Customer Focused',
    description:
      "Our customers' success is our success. We listen, adapt, and deliver solutions that truly solve real-world problems.",
  },
  {
    icon: Lightbulb,
    title: 'Innovation Driven',
    description:
      'We constantly push boundaries to develop cutting-edge solutions that stay ahead of emerging threats and challenges.',
  },
  {
    icon: Heart,
    title: 'Integrity Always',
    description:
      'We operate with transparency and honesty in everything we do, building trust through consistent ethical behavior.',
  },
  {
    icon: Target,
    title: 'Excellence Pursued',
    description:
      'We hold ourselves to the highest standards, continuously improving our products and processes to deliver exceptional quality.',
  },
  {
    icon: Award,
    title: 'Empowerment',
    description:
      'We empower organizations of all sizes to take control of their data privacy with accessible, powerful tools.',
  },
];

export const TEAM: TeamInfo[] = [
  {
    name: 'Charles de Jager',
    role: 'CEO & Founder',
    bio: '25+ years in information technology primarily focused on data and analytics. Data privacy advocate.',
    initials: 'CD',
    imageUrl: '/assets/team/charles-de-jager.png',
    linkedInUrl: 'https://www.linkedin.com/in/charlesdejager/',
  },
  // {
  //   name: 'Sarah Martinez',
  //   role: 'CTO & Co-Founder',
  //   bio: 'Expert in privacy-preserving technologies and distributed systems architecture.',
  //   initials: 'SM',
  // },
  // {
  //   name: 'Michael Thompson',
  //   role: 'VP of Engineering',
  //   bio: 'Led engineering teams at major tech companies, passionate about secure software.',
  //   initials: 'MT',
  // },
  // {
  //   name: 'Emily Watson',
  //   role: 'Head of Product',
  //   bio: 'Combines deep UX expertise with privacy compliance knowledge.',
  //   initials: 'EW',
  // },
  // {
  //   name: 'David Kim',
  //   role: 'Chief Privacy Officer',
  //   bio: 'Former privacy regulator with expertise in GDPR, CCPA, and global frameworks.',
  //   initials: 'DK',
  // },
  // {
  //   name: 'Jennifer Liu',
  //   role: 'VP of Customer Success',
  //   bio: 'Dedicated to ensuring customers achieve their privacy and compliance goals.',
  //   initials: 'JL',
  // },
];
